import SrMultipleText from "./SrMultipleText.vue";

SrMultipleText.install = function(Vue) {
  Vue.component(SrMultipleText.name, SrMultipleText);
};

export default SrMultipleText;


// WEBPACK FOOTER //
// ./packages/SrMultipleText/index.js